import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { ApiService } from 'src/app/services/api/api.service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { Report, TOTALTERMINAL, TraxReport } from 'src/app/Classes/reportAllxlsx';
import { hourlySalesReport } from './hourlySalesReport';
import { taxTranscReport } from './taxTranscReport';
import { paymentTypeAnalysisReport } from './paymentTypeAnalysis';
import { tranxDetailAnalysisReport } from './tranxDetailAnalysis';
import { termCollectionReport } from './termCollectionReport';
import { MessageService } from 'primeng/api';
import { MASSTORE, MASPRICELEVEL } from 'src/app/Classes/mas-store';
import { MASSHIFT } from 'src/app/Classes/mas-pos';
import { MASUSER } from 'src/app/Classes/mas-user';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AllTerminalDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-terminal-dialogs/all-terminal-dialogs.component';
import { AllStoreDialogComponent } from 'src/app/components/dialogs/report-dialog/all-store-dialog/all-store-dialog.component';
import { AllPaymenttypeDialogComponent } from 'src/app/components/dialogs/report-dialog/all-paymenttype-dialog/all-paymenttype-dialog.component';
import { AllShiftDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-shift-dialogs/all-shift-dialogs.component';
import { AllOperatorDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-operator-dialogs/all-operator-dialogs.component';
import { AllPricelevelDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-pricelevel-dialogs/all-pricelevel-dialogs.component';
import { AllPriceshiftDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-priceshift-dialogs/all-priceshift-dialogs.component';
import { log } from 'console';
import { AllStockcodeDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-stockcode-dialogs/all-stockcode-dialogs.component';
import { AllCategoryDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-category-dialogs/all-category-dialogs.component';
import { AllGroupDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-group-dialogs/all-group-dialogs.component';
import { AllDepartmentDialogsComponent } from 'src/app/components/dialogs/report-dialog/all-department-dialogs/all-department-dialogs.component';
import { Router } from '@angular/router';




@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  providers: [MessageService]
})
export class ReportsComponent {

  // reportType = [
  //   { id: '1', type: 'All Sales Report' },
  // ];
  // reportTraxType = [
  //   { id: '1', type: 'All Transaction Report' },
  //   { id: '2', type: 'Transaction Report' },
  //   { id: '3', type: 'Operation Report' },
  // ];

  // file_type = 'xls';
  // mySelectedDate = ['Today','Yesterday','Last Week','Last Month', 'Last Year', 'Custom Date'];
  // selectedDate:string="Today";

  // mySelectedGroup = ['Store','Store Terminal'];
  // selectedGroup:string="Store";

  // selectedInactiveStock: string = '';

  // stores : MASSTORE[];
  // shifts : MASSHIFT[];
  // operators : any;
  // groups : any;
  // categories : any;
  // selectedStore:{ code: string, desc: string};
  // AllselectedStore: any[] = [];
  // AllselectedGroup: any[] = [];
  // AllselectedShift: any[] = [];
  // AllselectedOperator: any[] = [];
  // AllselectedCategory: any[] = [];
  // AllselectedTerminal: any[] = [];
  // AllselectedDepartment: any[] = [];
  // AllselectedPayment: any[] = [];
  // AllselectedPriceLevel: any[] = [];
  // AllselectedPriceShift: any[] = [];
  // AllselectedStock: any[] = [];
  // storeCode:any[]=[];
  // groupCode:any[]=[];
  // storeId:string;
  // terminalCode:any[]=[];
  // departmentCode:any[]=[];
  // shiftCode:any[]=[];
  // OperatorCode:any[]=[];
  // CategoryCode:any[]=[];
  // convertDayString:string;
  // isTransactionVoidChecked: any;
  // isTransactionVoidCheckboxChecked: any;
  // isDiscountItemChecked: any;
  // isDiscountItemCheckboxChecked: any;
  // isFocItemChecked: any;
  // isFocItemCheckboxChecked: any;
  // isItemCancelChecked: any;
  // isItemCancelCheckboxChecked: any;
  // isChangedPriceChecked: any;
  // isChangedPriceCheckboxChecked: any;
  // isCombineVoidChecked: any;
  // isCombineVoidCheckboxChecked: any;
  // isNormalSalesChecked:any;
  // isNormalSalesCheckboxChecked:any;
  // isRemark1Checked:any;
  // isRemark1CheckboxChecked:any;
  // isShiftChecked:any;
  // isTaxChecked:any
  // isTransactionVoidV1Checked:any;
  // isTaxV2Checked:any
  // isTaxV2CheckboxChecked:any
  // options: any[] = [];
  // selectedOption: any = '';
  // @Output() optionSelected = new EventEmitter<any>();

  // selectedReportType: string;
  // selectedTraxReportType : string;
  // filterHourlySalesform=false;
  // filterTaxTransactionform=false;
  // filterform3=false;
  // filterform4=false;
  // downloadbtn = true;
  // filterbtn= false;
  // hideSalesReport=false;
  // isLoading = false;

  // hourReportData:any;
  // taxReportData:any;
  // paymentTypeData:any;
  // tranxDetailData:any;
  // terminalCollectionData:any;

  // startDate:any;
  // endDate:any;
  // currentlyChecked:any;
  // salesCurrentlyChecked:any  
  // reports: Report[];
  // TraxReports: TraxReport[];
  // TerminalList:TOTALTERMINAL[]=[];
  // DepartmentList:any[]=[];
  // PaymentType:any;
  // stock:any;
  // priceLevel:any;
  // priceShift:any;
  // PaymentCode:any[]=[];
  // PriceLevelCode:any[]=[];
  // PriceShiftCode:any[]=[];
  // StockCode:any[]=[];
  // pushPaymentCode:any;
  // pushPriceLevelCode:any;
  // pushPriceShiftCode:any;
  // pushStockCode:any;
  // sortingOptions: any[] = [
  //   { id: 'checkbox1', value: 'SALES_CTRNO', label: 'Store Terminal' },
  //   { id: 'checkbox2', value: 'SALES_CLOSEDATE', label: 'Date' },
  //   { id: 'checkbox3', value: 'SALES_RCPTNO', label: 'Receipt' },
  //   { id: 'checkbox4', value: 'PYMT_CTRNO', label: 'Terminal No.' },
  //   { id: 'checkbox5', value: 'SALES_SALES_OPERID', label: 'Operator' },
  //   { id: 'checkbox6', value: 'SALES_SHIFT', label: 'Shift' },
  //   { id: 'checkbox7', value: 'SALES_STATUS', label: 'Status' },
  //   { id: 'checkbox8', value: 'SALES_TRANSNO', label: 'Receipt' },
  //   { id: 'checkbox9', value: 'SDTL_CLOSEDATE', label: 'Date' },
  //   { id: 'checkbox10', value: 'SDTL_CTRNO', label: 'Terminal' },
  //   { id: 'checkbox11', value: 'SDTL_TRANSNO', label: 'Receipt' },
  //   { id: 'checkbox12', value: 'SDTL_SALES_SHIFT', label: 'Shift' },
  //   { id: 'checkbox13', value: 'SDTL_SALES_OPERID', label: 'Operator' },
  //   { id: 'checkbox14', value: 'SDTL_STATUS', label: 'Status' },
  //   { id: 'checkbox15', value: 'SDTL_STOCK_CODE', label: 'Stock Code' },
  //   { id: 'checkbox16', value: 'SDTL_SHORTDESC', label: 'Description' }, 
  //   { id: 'checkbox17', value: 'SALES_OPERID', label: 'Operator' },
  //   { id: 'checkbox18', value: 'SALES_REMARK1', label: 'Remark 1' },
  //   { id: 'checkbox19', value: 'SALES_REMARK2', label: 'Remark 2' },
  //   { id: 'checkbox20', value: 'SALES_REMARK3', label: 'Remark 3' },
  //   { id: 'checkbox21', value: 'SDTL_STORE', label: 'Stock Code' },
  //   { id: 'checkbox22', value: 'SDTL_BARCODE', label: 'Barcode' },
  //   { id: 'checkbox23', value: 'SDTL_QTY', label: 'Quantity' },
  //   { id: 'checkbox24', value: 'SDTL_NETSALES', label: 'Amount' },
  //   { id: 'checkbox25', value: 'CI_CLOSEDATE', label: 'Date' },
  // ];
  // salesSortingOptions: any[] = [
  //   { id: '', value: 'gross', label: 'Gross Sales' },
  //   { id: '', value: 'net', label: 'Net Sales' },
  //   { id: '', value: 'total', label: 'Total Sales' },
  // ];
  // sortNaming:string;
  // saleSortNaming:string;

  // inactivestocklisting = [
  //   { id: '1', value: 'M_STOCK_CODE', label: 'Stock Code' },
  //   { id: '2', value: 'M_DESC', label: 'Stock Description 1' },
  //   { id: '3', value: 'M_DESC2', label: 'Stock Description 2' },
  //   { id: '4', value: 'M_BARCODE', label: 'Barcode' },
  // ];
  

  // constructor(private router: Router,private messageService: MessageService,private apiService: ApiService,public datePipe: DatePipe,public dialogRef: MatDialog) {
    
  //   this.reports = [
  //     // new Report('Hourly Sales Report')
  //   ];
  //   this.TraxReports = [
  //     new TraxReport('Transaction Detail Analysis','Transaction Report',this.sortingOptions),
  //     new TraxReport('Payment Type Analysis Report','Transaction Report',this.sortingOptions),
  //     new TraxReport('Terminal Collection Report','Transaction Report',this.sortingOptions),
  //     new TraxReport('Hourly Sales Report','Operation Report',this.sortingOptions),
  //     new TraxReport('Tax Transaction Report','Operation Report',this.sortingOptions),
  //     new TraxReport('Category Sales Report','Operation Report',this.sortingOptions),
  //     new TraxReport('Department Sales Report','Operation Report',this.sortingOptions),
  //     new TraxReport('Group Sales Report','Operation Report',this.sortingOptions),
  //     new TraxReport('SKU Sales Report','Operation Report',this.sortingOptions),
  //     new TraxReport('Transaction Sales Report','Operation Report',this.sortingOptions),
  //     new TraxReport('Transaction Void Report','Operation Report',this.sortingOptions),
  //     new TraxReport('Item Report By Price Level Shift','Operation Report',this.sortingOptions),
  //     new TraxReport('Sales Remark','Operation Report',this.sortingOptions),
  //     new TraxReport('Sold Item Analysis','Operation Report',this.sortingOptions),
  //     new TraxReport('Operator Collection','Operation Report',this.sortingOptions),
  //     new TraxReport('Vendor Voucher','Operation Report',this.sortingOptions),
  //     new TraxReport('Store Voucher','Operation Report',this.sortingOptions),
  //     new TraxReport('Receipt Analysis','Operation Report',this.sortingOptions),
  //     new TraxReport('Inactive Stock','Operation Report',this.sortingOptions),
  //     new TraxReport('Average Sales Summary','Operation Report',this.sortingOptions, this.salesSortingOptions),
  //   ];
        
  // }

  // getCurrentDate() {
  //   const date = new Date();
  //   const year = date.getFullYear();
  //   const month = ('0' + (date.getMonth() + 1)).slice(-2);
  //   const day = ('0' + date.getDate()).slice(-2);
  //   this.startDate = year + '-' + month + '-' + day;
  //   this.endDate = year + '-' + month + '-' + day;
  //   return year + '-' + month + '-' + day;
  // }

  // async ngOnInit(): Promise<void> {
  //   this.getFilterStores();
  //   this.getPaymentType();
  //   this.getCurrentDate();
  //   this.getFilterShift();
  //   this.getFilterOperator();
  //   this.getFilterGroup();
  //   this.getFilterCategory();
  //   this.getPriceLevel();
  //   this.getPriceShift();
  //   this.getFilterStock();
  //   this.selectedTraxReportType = this.reportTraxType[0].type;
  // }

  // handleStartDateChange(event: Event) {
  //    this.startDate = (<HTMLInputElement>event.target).value;
  //   // const temp_date = (<HTMLInputElement>event.target).value;
  //   // this.startDate = moment(temp_date).format('YYYY-MM-DD');
  // }
  
  // handleEndDateChange(event: Event) {
  //   this.endDate = (<HTMLInputElement>event.target).value;
  // }

  // handleStoreIDChange(event: Event) {
  //   this.storeId = (<HTMLInputElement>event.target).value;
  // }

  // filterTraxReports(): TraxReport[] {
  //   if (this.selectedTraxReportType == 'All Transaction Report') {
  //     return this.TraxReports;
  //   }
  
  //   const filteredReports = this.TraxReports.filter(report => report.ReportTitle === this.selectedTraxReportType);
    
  //   return filteredReports;
  // }
  
  // mappingDay()
  // {
  //   const mapping:any = {
  //     "Today": "today",
  //     "Yesterday": "yesterday",
  //     "Last Week":"lweek",
  //     "Last Month":"lmth",
  //     "Last Year":"lyear",
  //     "Custom Date":"custom"
  //     // Add more mappings here
  //   };
  //   if (mapping[this.selectedDate]) {
  //     this.convertDayString = mapping[this.selectedDate];
  //   } else {
  //     // Handle unknown values or throw an error
  //   }
  // }

  // async exportExcel(name:any) {
    
  //   if(this.isTransactionVoidCheckboxChecked)
  //   {
  //     this.isTransactionVoidChecked = 'T';
  //   }
  //   else
  //   {
  //     this.isTransactionVoidChecked = 'F';
  //   }

  //   if(this.isShiftChecked == undefined)
  //   {
  //     this.isShiftChecked = false;
  //   }

  //   if(this.isTaxChecked == undefined)
  //   {
  //     this.isTaxChecked = false;
  //   }

  //   if(this.isTransactionVoidV1Checked == undefined)
  //   {
  //     this.isTransactionVoidV1Checked = false;
  //   }

  //   if(this.isTaxV2CheckboxChecked)
  //   {
  //     this.isTaxV2Checked = 'T';
  //   }
  //   else
  //   {
  //     this.isTaxV2Checked = 'F';
  //   }

  //   if(this.isChangedPriceCheckboxChecked)
  //   {
  //     this.isChangedPriceChecked = 'T';
  //   }
  //   else
  //   {
  //     this.isChangedPriceChecked = 'F';
  //   }

  //   if(this.isItemCancelCheckboxChecked)
  //   {
  //     this.isItemCancelChecked = 'T';
  //   }
  //   else
  //   {
  //     this.isItemCancelChecked = 'F';
  //   }


  //   if(this.isFocItemCheckboxChecked)
  //   {
  //     this.isFocItemChecked = 'T';
  //   }
  //   else
  //   {
  //     this.isFocItemChecked = 'F';
  //   }

  //   if(this.isDiscountItemCheckboxChecked)
  //   {
  //     this.isDiscountItemChecked = 'T';
  //   }
  //   else
  //   {
  //     this.isDiscountItemChecked = 'F';
  //   }

  //   if(this.isCombineVoidCheckboxChecked)
  //   {
  //     this.isCombineVoidChecked = 'T';
  //   }
  //   else
  //   {
  //     this.isCombineVoidChecked = 'F';
  //   }

  //   if(this.isNormalSalesCheckboxChecked)
  //   {
  //     this.isNormalSalesChecked = 'T';
  //   }
  //   else
  //   {
  //     this.isNormalSalesChecked = 'F';
  //   }

  //   if(this.isRemark1CheckboxChecked)
  //   {
  //     this.isRemark1Checked = 'T';
  //   }
  //   else
  //   {
  //     this.isRemark1Checked = 'F';
  //   }
    
    
  //   const specificReport = this.TraxReports.find(report => report.name === name);
  //   if(specificReport.isSortingOptionChangeTriggered == false)
  //   {
  //     if (specificReport) {
  //       specificReport.openit();
  //       this.currentlyChecked = specificReport.GetFirstSortingResult;
  //     } else {
        
  //     }
  //   }

  //   if(specificReport.isSalesSortingOptionChangeTriggered == false)
  //   {
  //     if (specificReport) {
  //       specificReport.openit();
  //       this.salesCurrentlyChecked = specificReport.GetSalesSortingResult;
  //     } else {
        
  //     }
  //   }

  //   this.mappingDay();

  //   if(this.startDate == '' || this.endDate == '')
  //   {
  //     this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please insert Start Date and End Date', life: 3000 });
  //     return;
  //   }
  //   else
  //   {
  //     // if(name == 'Hourly Sales Report')
  //     // {
  //     //   this.isLoading = true;
  //     //   await this.apiService.HourlySalesReport(this.convertDayString,this.storeCode,this.terminalCode,this.selectedGroup,this.startDate,this.endDate,this.file_type,() => {
  //     //     // This callback is called when the operation is complete
  //     //     this.isLoading = false; // Hide loading indicator
  //     //   })
  //     // }
  //      if(name == 'Tax Transaction Report')
  //     {
  //       if(this.currentlyChecked == 'SALES_CTRNO' || this.currentlyChecked === undefined)
  //       { 
  //         this.currentlyChecked = 'SALES_CTRNO'
  //         this.sortNaming = 'Store Terminal' 
  //       }
  //       else if(this.currentlyChecked == 'SALES_CLOSEDATE')
  //       { this.sortNaming = 'Date' }
  //       else if(this.currentlyChecked =='SALES_RCPTNO')
  //       { this.sortNaming = 'Receipt' }
        
  //       this.isLoading = true;
  //       // await this.apiService.TaxTranscReport(this.convertDayString,this.storeCode,this.terminalCode,this.currentlyChecked,this.isTransactionVoidChecked,this.startDate,this.endDate,this.file_type, () => {
  //       //   // This callback is called when the operation is complete
  //       //   this.isLoading = false; // Hide loading indicator
  //       // })
  //     }
  //     else if(name == 'Payment Type Analysis Report')
  //     {
        
  //       this.isLoading = true;
  //       await this.apiService.PaymentTypeAnalysisReport(this.convertDayString,this.storeCode,this.terminalCode,this.PaymentCode,this.isTransactionVoidV1Checked,this.isShiftChecked,this.startDate,this.endDate,this.file_type, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Transaction Detail Analysis')
  //     {
        
  //       if (this.currentlyChecked == 'SALES_CLOSEDATE')
  //       {
  //         this.currentlyChecked = 'PYMT_CLOSEDATE'
  //         this.sortNaming = "Date"
  //       }
  //       else if(this.currentlyChecked == 'SALES_CTRNO' || this.currentlyChecked === undefined)
  //       {
  //         this.currentlyChecked = 'PYMT_CTRNO'
  //         this.sortNaming ='Store Terminal'
  //       }
  //       this.isLoading = true;
  //       await this.apiService.TranxDetailsReport(this.convertDayString,this.storeCode,this.terminalCode,this.currentlyChecked,this.isTaxChecked,this.startDate,this.endDate,this.file_type, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }

  //     else if(name == 'Vendor Voucher')
  //     {        
  //       if (this.currentlyChecked == 'SDTL_CLOSEDATE' || this.currentlyChecked === undefined)
  //       {
  //         this.currentlyChecked = 'SDTL_CLOSEDATE'
  //         this.sortNaming = "Date"
  //       }
  //       else if(this.currentlyChecked == 'SDTL_CTRNO')
  //       {
  //         this.sortNaming ='Terminal'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_TRANSNO')
  //       {
  //         this.sortNaming ='Receipt'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_SALES_SHIFT')
  //       {
  //         this.sortNaming ='Shift'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_SALES_OPERID')
  //       {
  //         this.sortNaming ='Operator'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_STATUS')
  //       {
  //         this.sortNaming ='Status'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_STOCK_CODE')
  //       {
  //         this.sortNaming ='Stock Code'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_SHORTDESC')
  //       {
  //         this.sortNaming ='Description'
  //       }
  //       this.isLoading = true;
  //         await this.apiService.VendorVoucherReport(this.file_type, this.storeCode, this.startDate, this.endDate, this.convertDayString, this.OperatorCode, this.currentlyChecked, this.terminalCode, this.StockCode, this.groupCode, this.departmentCode, this.CategoryCode, this.shiftCode, () => {
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Sold Item Analysis')
  //     {
  //       this.isLoading = true;
  //         await this.apiService.SoldItem(this.file_type, this.storeCode, this.startDate, this.endDate, this.convertDayString, this.isChangedPriceChecked, this.isItemCancelChecked, this.isFocItemChecked, this.isDiscountItemChecked, this.isTransactionVoidChecked, this.isCombineVoidChecked, this.isNormalSalesChecked, this.OperatorCode, this.terminalCode, this.StockCode, this.groupCode, this.departmentCode, this.CategoryCode, () => {
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Receipt Analysis')
  //     {
  //       if (this.currentlyChecked == 'SALES_CLOSEDATE' || this.currentlyChecked === undefined)
  //       {
  //         this.currentlyChecked = 'SALES_CLOSEDATE'
  //         this.sortNaming = "Date"
  //       }
  //       else if(this.currentlyChecked == 'SALES_SHIFT')
  //       {
  //         this.sortNaming ='Shift'
  //       }
  //       else if(this.currentlyChecked == 'SALES_STATUS')
  //       {
  //         this.sortNaming ='Status'
  //       }
  //       else if(this.currentlyChecked == 'SALES_TRANSNO')
  //       {
  //         this.sortNaming ='Receipt'
  //       }
  //       else if(this.currentlyChecked == 'SALES_OPERID')
  //       {
  //         this.sortNaming ='Operator'
  //       }
  //       else if(this.currentlyChecked == 'SALES_REMARK1')
  //       {
  //         this.sortNaming ='Remark 1'
  //       }
  //       else if(this.currentlyChecked == 'SALES_REMARK2')
  //       {
  //         this.sortNaming ='Remark 2'
  //       }
  //       this.isLoading = true;
  //         await this.apiService.ReceiptAnalysis(this.file_type, this.storeCode, this.startDate, this.endDate, this.convertDayString, this.currentlyChecked, this.terminalCode,  this.isTransactionVoidChecked, this.isCombineVoidChecked, this.isNormalSalesChecked, this.isRemark1Checked, () => {
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }

  //     else if(name == 'Sales Remark')
  //     {
  //       if (this.currentlyChecked == 'SALES_REMARK1' || this.currentlyChecked === undefined)
  //       {
  //         this.currentlyChecked = 'SALES_REMARK1';
  //         this.sortNaming = "Remark 1";
  //       }
  //       else if(this.currentlyChecked == 'SALES_REMARK2')
  //       {
  //         this.sortNaming ='Remark 2'
  //       }
  //       else if(this.currentlyChecked == 'SALES_REMARK3')
  //       {
  //         this.sortNaming ='Remark 3'
  //       }
  //       this.isLoading = true;
  //         await this.apiService.SalesRemark(this.startDate, this.endDate, this.currentlyChecked,this.storeCode, this.convertDayString, this.file_type, this.terminalCode, this.isTransactionVoidChecked,  () => {
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Store Voucher')
  //     {        
  //       if (this.currentlyChecked == 'SALES_CLOSEDATE')
  //       {
  //         this.sortNaming = "Date"
  //       }
  //       else if(this.currentlyChecked == 'SALES_CTRNO' || this.currentlyChecked === undefined)
  //       {
  //         this.currentlyChecked = 'SALES_CTRNO'
  //         this.sortNaming ='Store Terminal'
  //       }
  //       else if(this.currentlyChecked == 'SALES_SALES_OPERID')
  //       {
  //         this.sortNaming ='Operator'
  //       }
  //       else if(this.currentlyChecked == 'SALES_SHIFT')
  //       {
  //         this.sortNaming ='Shift'
  //       }
  //       else if(this.currentlyChecked == 'SALES_STATUS')
  //       {
  //         this.sortNaming ='Status'
  //       }
  //       else if(this.currentlyChecked == 'SALES_TRANSNO')
  //       {
  //         this.sortNaming ='Receipt'
  //       }
  //       this.isLoading = true;
  //         await this.apiService.StoreVoucherReport(this.file_type, this.storeCode, this.startDate, this.endDate, this.convertDayString, this.OperatorCode, this.currentlyChecked, this.terminalCode, this.shiftCode, () => {
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Item Report By Price Level Shift')
  //     {
        
  //       if (this.currentlyChecked == 'SDTL_SHORTDESC' || this.currentlyChecked === undefined)
  //       {
  //         this.currentlyChecked = 'SDTL_SHORTDESC'
  //         this.sortNaming = "Description"
  //       }
  //       else if(this.currentlyChecked == 'SDTL_BARCODE')
  //       {
  //         this.sortNaming ='Barcode'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_QTY')
  //       {
  //         this.sortNaming ='Quantity'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_STORE')
  //       {
  //         this.sortNaming ='Stock Code'
  //       }
  //       else if(this.currentlyChecked == 'SDTL_NETSALES')
  //       {
  //         this.sortNaming ='Amount'
  //       }
  //       this.isLoading = true;
        
  //       // await this.apiService.ItemReport(this.startDate,this.endDate,this.currentlyChecked,this.storeCode,this.convertDayString,this.file_type,this.PriceShiftCode.length > 0 ? this.PriceShiftCode[0] : '',this.PriceLevelCode.length > 0 ? this.PriceLevelCode[0] : '',this.StockCode, () => {
  //         await this.apiService.ItemReport(this.startDate,this.endDate,this.currentlyChecked,this.storeCode,this.convertDayString,this.file_type,this.PriceShiftCode,this.PriceLevelCode,this.StockCode, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Average Sales Summary')
  //     {
        
  //       if (this.currentlyChecked == 'CI_CLOSEDATE' || this.currentlyChecked === undefined)
  //       {
  //         this.currentlyChecked = 'CI_CLOSEDATE'
  //         this.sortNaming = "Date"
  //       }
  //       if(this.salesCurrentlyChecked == 'GROSS' || this.salesCurrentlyChecked === undefined)
  //       {
  //         this.salesCurrentlyChecked = 'GROSS'
  //         this.saleSortNaming ='Gross Sales'
  //       }
  //       else if(this.salesCurrentlyChecked == 'NET')
  //       {
  //         this.saleSortNaming ='Net Sales'
  //       }
  //       else if(this.salesCurrentlyChecked == 'TOTAL')
  //       {
  //         this.saleSortNaming ='Total Sales'
  //       }

  //       this.isLoading = true;
  //       // await this.apiService.AverageSalesSummary(this.file_type,this.storeCode,this.startDate,this.endDate,this.convertDayString,this.isTaxV2Checked,this.salesCurrentlyChecked,this.currentlyChecked, () => {
  //       //   this.isLoading = false; 
  //       // })
  //     }
  //     else if(name == 'Operator Collection')
  //     {
  //       this.isLoading = true;
  //       await this.apiService.OperatorCollection(this.file_type,this.storeCode,this.startDate,this.endDate,this.convertDayString,this.OperatorCode, () => {
  //         this.isLoading = false; 
  //       })
  //     }
  //     else if(name == 'Terminal Collection Report')
  //     {
  //       if (this.currentlyChecked == 'SALES_CLOSEDATE' || this.currentlyChecked === undefined)
  //       {
  //         this.currentlyChecked = 'PYMT_CLOSEDATE'
  //         this.sortNaming = 'Date'
  //       }
  //       else if(this.currentlyChecked == 'SALES_CTRNO')
  //       {
  //         this.currentlyChecked = 'PYMT_CTRNO'
  //         this.sortNaming = 'Terminal No.'
  //       }
  //       this.isLoading = true;
  //       await this.apiService.TerminalCollectionReport(this.convertDayString,this.storeCode,this.terminalCode,this.currentlyChecked,this.startDate,this.endDate,this.PaymentCode,this.file_type, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }

  //     else if(name == 'Category Sales Report')
  //     {
  //       if(this.storeId == undefined){
  //         this.storeId = this.options[0].key;
  //       }
  //       this.isLoading = true;
  //       await this.apiService.CaterogrySalesReport(this.convertDayString,this.startDate,this.endDate,this.storeId,this.file_type, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Department Sales Report')
  //     {
  //       if(this.storeId == undefined){
  //         this.storeId = this.options[0].key;
  //       }
  //       this.isLoading = true;
  //       await this.apiService.DepartmentSalesReport(this.convertDayString,this.startDate,this.endDate,this.storeId,this.file_type, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Group Sales Report')
  //     {
  //       if(this.storeId == undefined){
  //         this.storeId = this.options[0].key;
  //       }
  //       this.isLoading = true;
  //       await this.apiService.GroupSalesReport(this.convertDayString,this.startDate,this.endDate,this.storeId,this.file_type, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'SKU Sales Report')
  //     {
  //       if(this.storeId == undefined){
  //         this.storeId = this.options[0].key;
  //       }
  //       this.isLoading = true;
  //       await this.apiService.SKUSalesReport(this.convertDayString,this.startDate,this.endDate,this.storeId,this.file_type, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Transaction Sales Report')
  //     {
  //       if(this.storeId == undefined){
  //         this.storeId = this.options[0].key;
  //       }
  //       this.isLoading = true;
  //       await this.apiService.TransactionSalesReport(this.file_type,this.storeId,this.startDate,this.endDate,this.convertDayString, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Transaction Void Report')
  //     {
  //       if(this.storeId == undefined){
  //         this.storeId = this.options[0].key;
  //       }
  //       this.isLoading = true;
  //       await this.apiService.TransactionVoidReport(this.convertDayString,this.startDate,this.endDate,this.storeId,this.file_type, () => {
  //         // This callback is called when the operation is complete
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //     else if(name == 'Inactive Stock')
  //     {
  //       this.isLoading = true;
        
  //       await this.apiService.InactiveStockReport(this.selectedInactiveStock,this.file_type, () => {
  //         this.isLoading = false; // Hide loading indicator
  //       })
  //     }
  //   }
    
  //   this.AllselectedStore = [];
  //   this.AllselectedStore = [];
  //   this.AllselectedGroup = [];
  //   this.AllselectedShift = [];
  //   this.AllselectedOperator = [];
  //   this.AllselectedCategory = [];
  //   this.AllselectedTerminal = [];
  //   this.AllselectedDepartment = [];
  //   this.AllselectedPayment = [];
  //   this.AllselectedPriceLevel = [];
  //   this.AllselectedPriceShift = [];
  //   this.AllselectedStock = []; 
  // }

  // async getFilterStores() {
  //   try {
  //     const data = await this.apiService.GetFilterStores().toPromise();
      
  //     this.stores = data;
      
  //     this.stores.forEach((store: any) => {
  //       this.options.push({ key: store.M_CODE, value: store.M_DESC });
        
  //     });

  //     if (this.options.length > 0) {
        
  //       this.selectedOption = this.options[0].key;
  //     }
  //   } catch (error) {
  //     console.error('Error retrieving stores:', error);
  //   }
  // }

  // selectStore()
  // {
  //   const dialogRef = this.dialogRef.open(AllStoreDialogComponent, {
  //     data: { title: 'Select Terminal',store:this.stores,checked:this.AllselectedStore },
  //     height: '553px',
  //     width: '678px',
  //     disableClose: true,
  //     autoFocus: false
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedStore = result;
  //     this.pushStoreCode();
  //     await this.functionCallTerminal()
  //   });
  // }

  // selectGroup()
  // {
  //   const dialogRef = this.dialogRef.open(AllGroupDialogsComponent, {
  //     data: { title: 'Select Terminal',group:this.groups,checked:this.AllselectedGroup },
  //     height: '553px',
  //     width: '678px',
  //     disableClose: true,
  //     autoFocus: false
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedGroup = result;
  //     this.pushGroupCode();
  //     await this.functionCallDepartment()
  //   });
  // }

  // getFilterOperator()
  // {
  //   this.apiService.GetFilterOperator().subscribe((data) => {
  //     this.operators = data;
  //   }, (error) => {
      
  //   });
  // }

  // getFilterGroup()
  // {
  //   this.apiService.GetFilterGroup().subscribe((data) => {
  //     this.groups = data;
  //   }, (error) => {
      
  //   });
  // }

  // getFilterCategory()
  // {
  //   this.apiService.GetFilterCategory().subscribe((data) => {
  //     this.categories = data;
  //   }, (error) => {
      
  //   });
  // }

  // filterOperator()
  // {
  //   const dialogRef = this.dialogRef.open(AllOperatorDialogsComponent, {
  //     data: { title: 'Select Terminal',operator:this.operators,checked:this.AllselectedOperator },
  //     height: '553px',
  //     width: '678px',
  //     disableClose: true,
  //     autoFocus: false
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedOperator = result;
  //     this.pushOperator();
  //   });
  // }

  // filterCategory()
  // {
  //   const dialogRef = this.dialogRef.open(AllCategoryDialogsComponent, {
  //     data: { title: 'Select Terminal',category:this.categories,checked:this.AllselectedCategory },
  //     height: '553px',
  //     width: '678px',
  //     disableClose: true,
  //     autoFocus: false
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedCategory = result;
  //     this.pushCategory();
  //   });
  // }

  // getFilterShift()
  // {
  //   this.apiService.GetFilterShift().subscribe((data) => {
  //     this.shifts = data;
  //   }, (error) => {
      
  //   });
  // }

  // filterShift()
  // {
  //   const dialogRef = this.dialogRef.open(AllShiftDialogsComponent, {
  //     data: { title: 'Select Terminal',shift:this.shifts,checked:this.AllselectedShift },
  //     height: '553px',
  //     width: '678px',
  //     disableClose: true,
  //     autoFocus: false
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedShift = result;
  //     this.pushShift();
  //   });
  // }

  // optionChanged() {
  //   this.optionSelected.emit(this.selectedOption);
  // }

  // getPaymentType()
  // {
  //   this.apiService.GetPaymentType().subscribe((data) => {
  //     this.pushPaymentCode = data;
  //   }, (error) => {
      
  //   });
  // }

  // pushPaymentType()
  // {
  //   this.PaymentCode = [];
  //   this.AllselectedPayment.forEach((payment: any) => {
  //     this.PaymentCode.push(payment.M_CODE);
  //   })
  // }

  // pushPriceLevel()
  // {
  //   this.PriceLevelCode = [];
  //   this.AllselectedPriceLevel.forEach((priceLevel: any) => {
  //     this.PriceLevelCode.push(priceLevel.M_CODE);
  //   })
  // }

  // pushPriceShift()
  // {
  //   this.PriceShiftCode = [];
  //   this.AllselectedPriceShift.forEach((priceShift: any) => {
  //     this.PriceShiftCode.push(priceShift.M_CODE);
  //   })
  // }

  // pushStock()
  // {
  //   this.StockCode = [];
  //   this.AllselectedStock.forEach((stock: any) => {
  //     this.StockCode.push(stock.M_STOCK_CODE);
  //   })
  // }

  // pushShift()
  // {
  //   this.shiftCode = [];
  //   this.AllselectedShift.forEach((shift: any) => {
  //     this.shiftCode.push(shift.M_CODE);
  //   })
  // }

  // pushOperator()
  // {
  //   this.OperatorCode = [];
  //   this.AllselectedOperator.forEach((operator: any) => {
  //     this.OperatorCode.push(operator.M_CODE);
  //   })
  // }

  // pushCategory()
  // {
  //   this.CategoryCode = [];
  //   this.AllselectedCategory.forEach((category: any) => {
  //     this.CategoryCode.push(category.M_CODE);
  //   })
  // }

  // getPriceLevel()
  // {
  //   this.apiService.GetFilterPriceLevel().subscribe((data) => {
  //     this.pushPriceLevelCode = data;
  //   }, (error) => {
      
  //   });
  // }

  // getPriceShift()
  // {
  //   this.apiService.GetFilterPriceShift().subscribe((data) => {
  //     this.pushPriceShiftCode = data;
  //   }, (error) => {
      
  //   });
  // }

  // getFilterStock()
  // {
  //   this.apiService.GetFilterStockCode().subscribe((data) => {
  //     this.pushStockCode = data;
  //   }, (error) => {
      
  //   });
  // }

  // selectPriceLevel()
  // {
  //   const dialogRef = this.dialogRef.open(AllPricelevelDialogsComponent, {
  //     data: { title: 'Select Terminal',priceLevel:this.pushPriceLevelCode,checked:this.AllselectedPriceLevel},
  //     height: '553px',
  //     width: '678px',
  //     autoFocus: false,
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedPriceLevel = result;
  //     this.pushPriceLevel();
  //   });
  // }

  // selectStock()
  // {
  //   const dialogRef = this.dialogRef.open(AllStockcodeDialogsComponent, {
  //     data: { title: 'Select Terminal',stock:this.pushStockCode,checked:this.AllselectedStock},
  //     height: '553px',
  //     width: '678px',
  //     autoFocus: false,
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedStock = result;
  //     this.pushStock();
  //   });
  // }

  // selectPriceShift()
  // {
  //   const dialogRef = this.dialogRef.open(AllPriceshiftDialogsComponent, {
  //     data: { title: 'Select Terminal',priceShift:this.pushPriceShiftCode,checked:this.AllselectedPriceShift},
  //     height: '553px',
  //     width: '678px',
  //     autoFocus: false,
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedPriceShift = result;
  //     this.pushPriceShift();
  //   });
  // }

  // selectPaymentType()
  // {
  //   const dialogRef = this.dialogRef.open(AllPaymenttypeDialogComponent, {
  //     data: { title: 'Select Terminal',paymentType:this.pushPaymentCode,checked:this.AllselectedPayment},
  //     height: '553px',
  //     width: '678px',
  //     autoFocus: false,
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe(async (result) => {
  //     this.AllselectedPayment = result;
  //     this.pushPaymentType();
  //   });
  // }

  // async removeChip(index: number): Promise<void> {
  //   const removedStore = this.AllselectedStore[index];
  //   this.AllselectedStore.splice(index, 1);
  //   this.pushStoreCode();
    
  //   this.AllselectedTerminal = this.AllselectedTerminal.filter(terminal => terminal.M_STORE !== removedStore.M_CODE);

    
  //   await this.functionCallTerminal();
  // }

  // async removeTerminalChip(index:number):Promise<void>
  // {
  //   this.AllselectedTerminal.splice(index,1)
  //   this.pushTerminalCode()
  // }

  // async removeDepartmentChip(index:number):Promise<void>
  // {    
  //   this.AllselectedDepartment.splice(index,1)
  //   this.pushDepartmentCode()
  // }

  // async removeGroupChip(index: number): Promise<void> {
  //   const removedGroup = this.AllselectedGroup[index];
    
  //   this.AllselectedGroup.splice(index, 1);
  //   this.pushGroupCode();
  //   this.AllselectedDepartment = this.AllselectedDepartment.filter(department => department.M_GROUP !== removedGroup.M_CODE);
    
  //   await this.functionCallDepartment();
  // }

  // async removeShiftChip(index:number):Promise<void>
  // {
  //   this.AllselectedShift.splice(index,1)
  //   this.pushShift();
  // }

  // async removeOperatorChip(index:number):Promise<void>
  // {
  //   this.AllselectedOperator.splice(index,1)
  //   this.pushOperator()
  // }

  // async removeCategoryChip(index:number):Promise<void>
  // {
  //   this.AllselectedCategory.splice(index,1)
  //   this.pushCategory()
  // }

  // async removePriceLevelChip(index: number): Promise<void> {
  //   this.AllselectedPriceLevel.splice(index, 1);
  //   this.pushPriceLevel();
  // }

  // async removeStockChip(index: number): Promise<void> {
  //   this.AllselectedStock.splice(index, 1);
  //   this.pushStock();
  // }

  // async removePriceShiftChip(index: number): Promise<void> {
  //   this.AllselectedPriceShift.splice(index, 1);
  //   this.pushPriceShift();
  // }

  // async removePaymentTypeChip(index: number): Promise<void> {
  //   this.AllselectedPayment.splice(index, 1);
  //   this.pushPaymentType();
  // }

  
  // async selectTerminal()
  // {
  //   const dialogRef = this.dialogRef.open(AllTerminalDialogsComponent, {
  //     data: { title: 'Select Terminal',terminal:this.TerminalList,checked:this.AllselectedTerminal },
  //     height: '553px',
  //     width: '720px',
  //     disableClose: true,
  //     autoFocus: false
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     this.AllselectedTerminal = result;
  //     this.pushTerminalCode()
  //   });
  // }

  // async selectDepartment()
  // {
  //   const dialogRef = this.dialogRef.open(AllDepartmentDialogsComponent, {
  //     data: { title: 'Select Department',department:this.DepartmentList,checked:this.AllselectedDepartment },
  //     height: '553px',
  //     width: '720px',
  //     disableClose: true,
  //     autoFocus: false
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     this.AllselectedDepartment = result;
  //     this.pushDepartmentCode()
  //   });
  // }

  // pushDepartmentCode()
  // {
  //   this.departmentCode = [];

  //   this.AllselectedDepartment.forEach((department: any) => {
  //     this.departmentCode.push(department.M_CODE);
  //   });
  // }

  // pushTerminalCode()
  // {
  //   this.terminalCode = [];

  //   this.AllselectedTerminal.forEach((terminal: any) => {
  //     this.terminalCode.push(terminal.M_CODE);
  //   });

  // }

  // pushStoreCode()
  // {
  //   this.storeCode = [];

  //   this.AllselectedStore.forEach((store: any) => {
  //     this.storeCode.push(store.M_CODE);
  //   });
  // }

  // pushGroupCode()
  // {
  //   this.groupCode = [];

  //   this.AllselectedGroup.forEach((group: any) => {
  //     this.groupCode.push(group.M_CODE);
  //   });
  // }

  // isTerminalListEmpty(): boolean {
  //   return this.TerminalList.length < 1;
  // }

  // isDepartmentListEmpty(): boolean {
    
  //   return this.DepartmentList.length < 1;
  // }

  // async functionCallTerminal() {
  //   try {
  //     this.TerminalList = [];
  //     this.TerminalList = await this.apiService.GetTerminal(this.storeCode).toPromise();

  //   } catch (error) {
  //     // Handle any error that occurred during the API call
  //     console.error(error);
  //   }
  // }

  // async functionCallDepartment() {
  //   try {
  //     this.DepartmentList = [];
  //     this.DepartmentList = await this.apiService.GetFilterDepartment(this.groupCode).toPromise();
      
  //   } catch (error) {
  //     // Handle any error that occurred during the API call
  //     console.error(error);
  //   }
  // }

  // onCheckboxChange() {

  //   if (this.isTransactionVoidCheckboxChecked) {
  //     this.isTransactionVoidChecked = "T"
  //   } else {
  //     this.isTransactionVoidChecked = "F"
  //   }

  // }

  // onDiscountItemCheckboxChange() {

  //   if (this.isDiscountItemCheckboxChecked) {
  //     this.isDiscountItemChecked = "T"
  //   } else {
  //     this.isDiscountItemChecked = "F"
  //   }

  // }

  // onFocItemCheckboxChange() {

  //   if (this.isFocItemCheckboxChecked) {
  //     this.isFocItemChecked = "T"
  //   } else {
  //     this.isFocItemChecked = "F"
  //   }

  // }

  // onItemCancelCheckboxChange() {

  //   if (this.isItemCancelCheckboxChecked) {
  //     this.isItemCancelChecked = "T"
  //   } else {
  //     this.isItemCancelChecked = "F"
  //   }

  // }

  // onChangedPriceCheckboxChange() {

  //   if (this.isChangedPriceCheckboxChecked) {
  //     this.isChangedPriceChecked = "T"
  //   } else {
  //     this.isChangedPriceChecked = "F"
  //   }

  // }

  // onCombineVoidCheckboxChange() {

  //   if (this.isCombineVoidCheckboxChecked) {
  //     this.isCombineVoidChecked = "T"
  //   } else {
  //     this.isCombineVoidChecked = "F"
  //   }

  // }

  // onNormalSalesCheckboxChange() {

  //   if (this.isNormalSalesCheckboxChecked) {
  //     this.isNormalSalesChecked = "T"
  //   } else {
  //     this.isNormalSalesChecked = "F"
  //   }

  // }

  // onRemark1CheckboxChange() {

  //   if (this.isRemark1CheckboxChecked) {
  //     this.isRemark1Checked = "T"
  //   } else {
  //     this.isRemark1Checked = "F"
  //   }

  // }

  // onShiftCheckboxChange() {

  //   if (this.isShiftChecked) {
  //     this.isShiftChecked = "true"
  //   } else {
  //     this.isShiftChecked = "false"
  //   }

  // }

  // onCheckboxV1Change() {

  //   if (this.isTransactionVoidV1Checked) {
  //     this.isTransactionVoidV1Checked = "true"
  //   } else {
  //     this.isTransactionVoidV1Checked = "false"
  //   }

  // }

  // onTaxCheckboxChange() {

  //   if (this.isTaxChecked) {
  //     this.isTaxChecked = "true"
  //   } else {
  //     this.isTaxChecked = "false"
  //   }

  // }

  // onTaxV2CheckboxChange() {

  //   if (this.onTaxV2CheckboxChange) {
  //     this.isTaxV2Checked = "T"
  //   } else {
  //     this.isTaxV2Checked = "F"
  //   }

  // }

  // handleSortingOptionChange(report: TraxReport)
  // { 
  //   report.isSortingOptionChangeTriggered = true;
  //   this.currentlyChecked = report.GetFirstSortingResult
    
  // }

  // handleSalesSortingOptionChange(report: TraxReport)
  // { 
  //   report.isSalesSortingOptionChangeTriggered = true;
  //   this.salesCurrentlyChecked = report.GetSalesSortingResult; 
  // }

  // openPreview(name:any) {

  //   let path = "";
  //   switch(name){
  //     case "Hourly Sales Report":
  //       path = '/preview/hoursales'
  //     break;
  //     case "Average Sales Summary":
  //       path = '/preview/averagesalessummary'
  //     break;
  //     case "Inactive Stock":
  //       path = '/preview/inactivestock'
  //     break;
  //     case "Receipt Analysis":
  //       path = '/preview/receiptanalysis'
  //     break;
  //     case "Store Voucher":
  //       path = '/preview/storevoucher'
  //     break;
  //     case "Vendor Voucher":
  //       path = '/preview/vendorvoucher'
  //     break;
  //     case "Operator Collection":
  //       path = '/preview/operatorcollection'
  //     break;
  //     case "Sold Item Analysis":
  //       path = '/preview/solditemanalysis'
  //     break;
  //     case "Sales Remark":
  //       path = '/preview/salesremark'
  //     break;
  //     case "Item Report By Price Level Shift":
  //       path = '/preview/pricelevelshift'
  //     break;
  //     case "Transaction Void Report":
  //       path = '/preview/transactionvoid'
  //     break;
  //     case "Transaction Detail Analysis":
  //       path = '/preview/transactionDetails'
  //     break;

  //     case "Payment Type Analysis Report":
  //       path = '/preview/paymentType'
  //     break;

  //     case "Terminal Collection Report":
  //       path = '/preview/terminalCollection'
  //     break;

  //     case "Hourly Sales Report":
  //       path = '/preview/hourSales'
  //     break;

  //     case "Tax Transaction Report":
  //       path = '/preview/taxTransaction'
  //     break;

  //     case "Category Sales Report":
  //       path = '/preview/categorySales'
  //     break;

  //     case "Department Sales Report":
  //       path = '/preview/departmentSales'
  //     break;

  //     case "Group Sales Report":
  //       path = '/preview/groupSales'
  //     break;

  //     case "SKU Sales Report":
  //       path = '/preview/skuSales'
  //     break;

  //     case "Transaction Sales Report":
  //       path = '/preview/transactionSales'
  //     break;

  //     default:
  //       path = '/preview/hourSales'
  //     break;

  //   }
  //   const url = this.router.serializeUrl(this.router.createUrlTree([path]));
  //   window.open(url, '_blank');
  // }
}